// extracted by mini-css-extract-plugin
export default {"legendIndicator":"opa-z","legendNew":"ppa-z"};